<script setup>
import { onBeforeMount, onMounted, onUnmounted, onUpdated} from "vue";
import InvoiceTransactionsRow from "../components/InvoiceTransactionsRow.vue";
import setTooltip from "../assets/js/tooltip.js";
import validSession from "../assets/js/valid-session.js";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'animate.css';
import { useRoute } from "vue-router";
import SkeletonLoad from "../components/SkeletonLoad.vue";
import emitter from "../assets/js/eventBus.js";
import startResize from "../assets/js/resize.js";
import { computed } from "vue";

let meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

const store = useStore();
const route = useRoute();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.transaction_value = {
        value: 0
    }

    store.state.invoice_load = true;

    store.state.accounts = [];
    store.state.cards = [];
    store.state.transations = [];
    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};
    store.state.loadingTransactions = true;
    store.state.savingTransaction = false;
    store.state.modalColor = '';

    store.state.selectedYear = new Date().getFullYear();
    store.state.selectedMonth = {
        index: new Date().getMonth(),
        number: new Date().getMonth() + 1,
        display: meses[new Date().getMonth()]
    };

    store.state.validation = {
        descHasError: false,
        descMessageError: '',
        accountError: false,
        accountMessageError: '',
        categorryError: false,
        categoryMessageError: ''
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: ''
    }

    store.state.card_details = {
        icon: '',
        name: '',
        id: ''
    };

    store.state.invoice_details = {
        before_amount: parseFloat(0),
        amount: parseFloat(0),
        close_date: '',
        due_date: '',
        id: '',
        order: 0,
        status: ''
    };

    store.state.suggestions = [];

    store.state.invoice_id = route.params.id ? route.params.id : 0;

    getInvoice(store.state.invoice_id);

    getCards();
    getAccounts();
    getExpenseCategories();
    getRevenueCategories();

})

const reload_data = () => {
    getInvoice(store.state.invoice_id);
};

const get_data = () => {

    emitter.emit('receive-data', { data: store.state.card_details.id+'-card' });

};

onMounted(() => {

    emitter.on('load-data', reload_data);
    emitter.on('get-data', get_data);

  setTooltip();
});

onUpdated(() => {
    if(!store.state.loadingTransactions){
        startResize(181);
    }
})

onUnmounted(() => {
    emitter.off('load-data', reload_data);
    emitter.off('get-data', get_data);
});

const getInvoice = async (id) => {

    axios.get('invoices/show/'+id)
    .then(res => {
        
        if(res.status == 200){

            store.state.card_details = {
                icon: res.data.card_icon,
                name: res.data.card_name,
                id: res.data.card_id
            };

            store.state.invoice_details = {
                before_amount: parseFloat(res.data.before_amount),
                current_amount: parseFloat(res.data.current_amount),
                payed_amount: parseFloat(res.data.payed_amount),
                close_date: res.data.close_date,
                due_date: res.data.due_date,
                id: res.data.id,
                order: res.data.order,
                status: res.data.status,
                payment: res.data.payment
            };

            store.state.selectedYear = new Date(res.data.due_date).getFullYear();
            store.state.selectedMonth = {
                index: new Date(res.data.due_date+'T01:00:00').getMonth(),
                number: new Date(res.data.due_date+'T01:00:00').getMonth() + 1,
                display: meses[new Date(res.data.due_date+'T01:00:00').getMonth()]
            };

            getTransaction(res.data.id);

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getInvoiceByOrder = async (order) => {

    axios.get('invoices/show-by-order?card='+store.state.card_details.id+'&order='+order)
    .then(res => {
        
        if(res.status == 200){

            store.state.card_details = {
                icon: res.data.card_icon,
                name: res.data.card_name,
                id: res.data.card_id
            };

            store.state.invoice_details = {
                before_amount: parseFloat(res.data.before_amount),
                current_amount: parseFloat(res.data.current_amount),
                payed_amount: parseFloat(res.data.payed_amount),
                close_date: res.data.close_date,
                due_date: res.data.due_date,
                id: res.data.id,
                order: res.data.order,
                status: res.data.status,
                payment: res.data.payment
            };

            store.state.selectedYear = new Date(res.data.due_date+'T01:00:00').getFullYear();
            store.state.selectedMonth = {
                index: new Date(res.data.due_date+'T01:00:00').getMonth(),
                number: new Date(res.data.due_date+'T01:00:00').getMonth() + 1,
                display: meses[new Date(res.data.due_date+'T01:00:00').getMonth()]
            };

            getTransaction(res.data.id);

            let nextURL = window.location.origin + '/fatura/'+res.data.id;
            let nextTitle = 'Agive Finanças';
            let nextState = { additionalInformation: 'Updated the URL with JS' };

            window.history.pushState(nextState, nextTitle, nextURL);
            window.history.replaceState(nextState, nextTitle, nextURL);

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getTransaction = async (invoice) => {

    store.state.loadingTransactions = true;

    axios.get('transactions?invoice='+invoice)
    .then(res => {
        
        if(res.status == 200){

            store.state.transations = res.data;
            store.state.loadingTransactions = false;
            store.state.invoice_load = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getAccounts = async () => {

    axios.get('accounts')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getCards = async () => {

    axios.get('credit-cards')
    .then(res => {
        
        if(res.status == 200){

            store.state.cards = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

    axios.get('categories?type=receita')
    .then(res => {

    if(res.status == 200){

        store.state.categoriesRevenue = res.data;

    }

    })
    .catch(err => {
        console.error(err); 
    })

}

const clearFields = () => {

    store.state.transaction_value.value = 0;

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: ''
    }

    store.state.suggestions = [];
}


const editTrasaction = (data) => {

    emitter.emit('edit-transaction', { data });
    emitter.emit('set-type', { data: data.type }, true);

}

const payTransation = (id, status) => {

    store.state.invoice_load = true;

    let url = '/transactions/pay/'+id;

    let data = new FormData();

    data.append('status', status == 'Paid' ? 'Unpaid' : 'Paid');

    axios.post(url, data)
    .then(res => {
        
        if(!res.data.error){

            toast('Lançamento atualizado com sucesso!', {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            getTransaction();
            clearFields();

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const slideDate = (direction) => {

    store.state.invoice_load = true;

    if(direction == 'prev'){

        let prev_month = store.state.selectedMonth.index > 0 ? store.state.selectedMonth.index - 1 : 11;
        let prev_year = store.state.selectedMonth.index > 0 ? store.state.selectedYear : store.state.selectedYear - 1;
        
        store.state.selectedYear = prev_year;
        store.state.selectedMonth = {
            index: prev_month,
            number: prev_month + 1,
            display: meses[prev_month]
        };

        getInvoiceByOrder(parseInt(store.state.invoice_details.order) - 1);

    }
    else if(direction == 'next'){

        let next_month = store.state.selectedMonth.index < 11 ? store.state.selectedMonth.index + 1 : 0;
        let next_year = store.state.selectedMonth.index < 11 ? store.state.selectedYear : store.state.selectedYear + 1;

        store.state.selectedYear = next_year;
        store.state.selectedMonth = {
            index: next_month,
            number: next_month + 1,
            display: meses[next_month]
        };

        getInvoiceByOrder(parseInt(store.state.invoice_details.order) + 1);

    }

}

const formatMoney = (v) => {
    let total = parseFloat(v);

    return total.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
        });
}

const formatDate = (d) => {
    
    let date = new Date(d);
    
    return date.toLocaleDateString('pt-BR', {timeZone: 'UTC'});

}

const rotate = (id) => {

    let element = document.getElementById(id);

    element.classList.toggle('fa-rotate-90');

}

const valid_status = (status, type) => {

        if(status == 'Open'){

            if(type == 'class'){
                return 'secondary';
            }
            else if(type == 'title'){
                return 'Em aberto';
            }

        }
        else if(status == 'Closed'){

            if(type == 'class'){
                return 'warning';
            }
            else if(type == 'title'){
                return 'Fechada';
            }

        }
        else if(status == 'Paid'){

            if(type == 'class'){
                return 'success';
            }
            else if(type == 'title'){
                return 'Paga';
            }
            
        }
        else if(status == 'Late'){

            if(type == 'class'){
                return 'error';
            }else if(type == 'title'){
                return 'Em Atraso';
            }          
        }
        else if(status == 'Current'){

            if(type == 'class'){
                return 'info';
            }else if(type == 'title'){
                return 'Atual';
            }          
        }

    }

</script>
<template>

    <div class="container-fluid invoice-page px-2 px-lg-3">
        <div class="row">
            <div class="col-12">
                <div class="invoice-shell" :class="darkMode ? 'invoice-shell-dark' : ''">
                    <div class="invoice-header shadow-sm" :class="darkMode ? 'darkmode' : ''">
                        <div class="invoice-header__card">
                            <div class="invoice-header__icon">
                                <SkeletonLoad
                                    :width='"50px"'
                                    :height="'50px'"
                                    :class="'rounded-4'"
                                    v-if="store.state.invoice_load"
                                />
                                <img v-else :src="store.state.card_details.icon" alt="" width="42" class="rounded-4">
                            </div>

                            <div class="invoice-header__card-info">
                                <SkeletonLoad
                                    :width='"120px"'
                                    :height="'26px'"
                                    v-if="store.state.invoice_load"
                                />
                                <template v-else>
                                    <h5 class="mb-0">{{ store.state.card_details.name }}</h5>
                                    <span>Fatura do cartão</span>
                                </template>
                            </div>
                        </div>

                        <div class="invoice-header__month-nav">
                            <button class="month-nav-btn" type="button" @click="slideDate('prev')">
                                <i class="fal fa-chevron-left"></i>
                            </button>

                            <div class="invoice-header__month-label">
                                {{ store.state.selectedMonth.display }} {{ store.state.selectedYear }}
                            </div>

                            <button class="month-nav-btn" type="button" @click="slideDate('next')">
                                <i class="fal fa-chevron-right"></i>
                            </button>
                        </div>

                        <div class="invoice-header__meta">
                            <span class="invoice-count-badge">
                                {{ store.state.transations.length }} {{ store.state.transations.length === 1 ? 'lançamento' : 'lançamentos' }}
                            </span>
                        </div>
                    </div>

                    <div id="transactionList" class="invoice-content shadow-sm" :class="!darkMode ? 'bg-white' : 'bg-222222'">

                        <div class="invoice-loading" v-if="store.state.loadingTransactions">
                            <div class="row align-items-center gx-2 gx-lg-3">

                                <div class="col-3 col-sm-2 col-lg-1 text-center">
                                    <SkeletonLoad
                                        :width='"52px"'
                                        :height="'52px'"
                                        :class="'rounded-4'"
                                    />
                                </div>
                                <div class="col-9 col-sm-10 col-lg-8">
                                    <div class="row align-items-center">
                                        <div class="col-12 col-lg-6">
                                            <SkeletonLoad
                                                :width="'90px'"
                                                :height="'20px'"
                                            />
                                            <SkeletonLoad
                                                :width="'120px'"
                                                :height="'20px'"
                                                :class="'mt-2'"
                                            />
                                        </div>
                                        <div class="col-12 col-lg-3 text-lg-center d-none d-lg-block">
                                            <SkeletonLoad
                                                :width="'90px'"
                                                :height="'20px'"
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 text-end mt-3 mt-lg-0">
                                    <SkeletonLoad
                                        :width="'90px'"
                                        :height="'20px'"
                                        :class="'float-end'"
                                    />
                                </div>

                            </div>
                        </div>

                        <div class="invoice-empty text-center" v-if="store.state.transations.length == 0 && !store.state.loadingTransactions">
                            <div class="invoice-empty__icon">
                                <i class="fal fa-receipt"></i>
                            </div>
                            <h6 class="mb-2">Nenhum lançamento cadastrado</h6>
                            <p class="mb-0">Quando houver compras ou parcelas nessa fatura, elas aparecerão aqui.</p>
                        </div>

                        <div class="col-12 trasaction-list" v-if="!store.state.loadingTransactions && store.state.transations.length > 0">

                            <InvoiceTransactionsRow 
                                v-for="(transation, index) in store.state.transations" :key="index"
                                :transaction = transation
                                @edit="editTrasaction"
                                @pay="payTransation"
                            />

                        </div>

                    </div>

                    <div class="invoice-summary shadow-sm" :class="darkMode ? 'darkmode' : ''">
                        <div class="invoice-summary__main">
                            <div class="invoice-summary__item invoice-summary__item--highlight">
                                <span>Valor da fatura</span>
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'120px'"
                                    :height="'22px'"
                                />
                                <strong v-else>{{ formatMoney((store.state.invoice_details.current_amount + store.state.invoice_details.before_amount)) }}</strong>
                            </div>

                            <div class="invoice-summary__item">
                                <span>Vencimento</span>
                                <SkeletonLoad
                                    v-if="store.state.loading_balance"
                                    :width="'100px'"
                                    :height="'22px'"
                                />
                                <strong v-else>{{ formatDate(store.state.invoice_details.due_date) }}</strong>
                            </div>

                            <div class="invoice-summary__item">
                                <span>Situação</span>
                                <div v-if="store.state.loading_balance">
                                    <SkeletonLoad
                                        :width="'76px'"
                                        :height="'24px'"
                                    />
                                </div>
                                <span v-else class="badge badge-sm invoice-status-badge" :class="'bg-'+valid_status(store.state.invoice_details.status, 'class')">
                                    {{valid_status(store.state.invoice_details.status, 'title')}}
                                </span>
                            </div>

                            <button
                                class="invoice-summary__toggle"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseBalance"
                                aria-expanded="false"
                                aria-controls="collapseBalance"
                                @click="rotate('balance_chevron')"
                            >
                                <span>Ver detalhes</span>
                                <i id="balance_chevron" class="fal fa-chevron-right"></i>
                            </button>
                        </div>

                        <div class="collapse" id="collapseBalance">
                            <div class="invoice-summary__details">
                                <div class="invoice-summary__detail-card">
                                    <span>Saldo anterior</span>
                                    <strong class="text-danger">{{ formatMoney(store.state.invoice_details.before_amount) }}</strong>
                                </div>

                                <div class="invoice-summary__detail-card">
                                    <span>Total do período</span>
                                    <strong class="text-danger">{{ formatMoney((store.state.invoice_details.current_amount + store.state.invoice_details.before_amount)) }}</strong>
                                </div>

                                <div class="invoice-summary__detail-card" v-if="store.state.invoice_details.payed_amount !== undefined">
                                    <span>Valor pago</span>
                                    <strong>{{ formatMoney(store.state.invoice_details.payed_amount) }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<style>
.invoice-page{
    padding-bottom: 18px;
}

.invoice-shell{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.invoice-header{
    background: linear-gradient(135deg, #213e60 0%, #294c74 100%);
    color: #fff;
    border-radius: 22px;
    padding: 18px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 30;
}

.invoice-header__card{
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
    flex: 1 1 0;
}

.invoice-header__icon{
    width: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.invoice-header__card-info{
    min-width: 0;
}

.invoice-header__card-info h5{
    color: #fff;
    font-weight: 700;
    line-height: 1.1;
}

.invoice-header__card-info span{
    display: block;
    color: rgba(255,255,255,.78);
    font-size: 0.92rem;
    margin-top: 4px;
}

.invoice-header__month-nav{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    flex: 0 1 auto;
}

.invoice-header__month-label{
    min-width: 180px;
    text-align: center;
    font-weight: 600;
    letter-spacing: .01em;
}

.month-nav-btn{
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,.18);
    background: rgba(255,255,255,.08);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: .2s ease;
}

.month-nav-btn:hover{
    background: rgba(255,255,255,.16);
    transform: translateY(-1px);
}

.invoice-header__meta{
    flex: 1 1 0;
    display: flex;
    justify-content: flex-end;
}

.invoice-count-badge{
    background: rgba(255,255,255,.12);
    border: 1px solid rgba(255,255,255,.12);
    color: #fff;
    padding: 8px 14px;
    border-radius: 999px;
    font-weight: 600;
    white-space: nowrap;
}

.invoice-content{
    border-radius: 22px;
}

.invoice-loading{
    padding: 22px 22px 18px;
}

.invoice-empty{
    padding: 42px 20px;
    color: #6b7a90;
}

.invoice-empty__icon{
    width: 64px;
    height: 64px;
    border-radius: 18px;
    margin: 0 auto 12px;
    background: #f4f6fb;
    color: #213e60;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

.invoice-summary{
    background: #fff;
    border-radius: 22px;
    padding: 18px 22px;
}

.invoice-summary__main{
    display: grid;
    grid-template-columns: minmax(180px,1.2fr) repeat(2, minmax(120px,.8fr)) auto;
    gap: 14px;
    align-items: center;
}

.invoice-summary__item{
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.invoice-summary__item span{
    font-size: .9rem;
    color: #6b7a90;
}

.invoice-summary__item strong{
    font-size: 1.1rem;
    color: #213e60;
    line-height: 1.2;
}

.invoice-summary__item--highlight{
    background: #f7f9fc;
    border: 1px solid #ebeff5;
    border-radius: 18px;
    padding: 14px 16px;
}

.invoice-status-badge{
    width: fit-content;
    padding: 6px 12px;
    border-radius: 999px;
    font-weight: 700;
}

.invoice-summary__toggle{
    border: 0;
    background: #f5f7fb;
    color: #213e60;
    height: 46px;
    border-radius: 14px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    font-weight: 600;
    transition: .2s ease;
}

.invoice-summary__toggle:hover{
    background: #edf2f8;
}

.invoice-summary__details{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #edf0f5;
}

.invoice-summary__detail-card{
    background: #fafbfd;
    border: 1px solid #edf0f5;
    border-radius: 16px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.invoice-summary__detail-card span{
    font-size: .9rem;
    color: #6b7a90;
}

.invoice-summary__detail-card strong{
    color: #213e60;
    font-size: 1rem;
}

.trasation-list-add-button{
    font-size: 18px;
}

.btn-gray{
    background-color: #67748e !important;
    color: #fff !important;
}

.modal-body.darkmode{
    background-color: #3d3d3d !important;
}

.trasaction-card-list{
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

.auto-complete-list{
    list-style-type: none;
    max-height: 120px;
    overflow-y: auto;
    overflow-x: hidden;
}

.auto-complete-list.darkmode{
    background-color: #3d3d3d !important;
}

@media (max-width: 991.98px){
    .invoice-header{
        display: grid;
        grid-template-columns: 1fr;
        padding: 18px;
        gap: 14px;
    }

    .invoice-header__card,
    .invoice-header__month-nav,
    .invoice-header__meta{
        justify-content: center;
        text-align: center;
    }

    .invoice-header__card{
        flex-direction: row;
    }

    .invoice-header__card-info{
        text-align: left;
    }

    .invoice-header__meta{
        justify-content: center;
    }

    .invoice-summary__main{
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .invoice-summary__toggle{
        grid-column: 1 / -1;
    }

    .invoice-summary__details{
        grid-template-columns: 1fr;
    }
}

@media (max-width: 575.98px) {
    .invoice-page{
        padding-left: 6px !important;
        padding-right: 6px !important;
    }

    .invoice-header,
    .invoice-content,
    .invoice-summary{
        border-radius: 18px;
    }

    .invoice-header{
        padding: 16px 14px;
    }

    .invoice-header__card{
        align-items: center;
        justify-content: flex-start;
    }

    .invoice-header__month-nav{
        gap: 8px;
    }

    .invoice-header__month-label{
        min-width: 0;
        font-size: .98rem;
    }

    .month-nav-btn{
        width: 36px;
        height: 36px;
    }

    .invoice-count-badge{
        font-size: .88rem;
        padding: 7px 12px;
    }

    .invoice-loading{
        padding: 18px 14px;
    }

    .invoice-summary{
        padding: 14px;
        margin-bottom: 100px;
    }

    .invoice-summary__main{
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .invoice-summary__item--highlight{
        padding: 12px 14px;
    }

    .invoice-summary__item strong{
        font-size: 1rem;
    }

    .trasation-list-add-button{
        font-size: 22px;
    }
}

@media (max-height: 700px) and (max-width: 575.98px){
    .trasaction-card-list{
        max-height: 44vh;
    }
}

@media (min-height: 701px) and (max-height: 750px) and (max-width: 575.98px){
    .trasaction-card-list{
        max-height: 49vh;
    }
}

@media (min-height: 751px) and (max-height: 900px) and (max-width: 575.98px){
    .trasaction-card-list{
        max-height: 55vh;
    }
}

@media (min-height: 751px) and (max-height: 900px) and (min-width: 900px) and (max-width: 1050px){
    .trasaction-card-list{
        max-height: 66vh;
    }
}

@media (min-height: 901px) and (max-height: 920px) and (max-width: 575.98px){
    .trasaction-card-list{
        max-height: 58vh;
    }
}

@media (min-height: 921px) and (max-height: 950px) and (max-width: 575.98px){
    .trasaction-card-list{
        max-height: 59vh;
    }
}

@media (min-height: 951px) and (max-height: 1050px) and (max-width: 780px){
    .trasaction-card-list{
        max-height: 62vh;
    }
}
</style>
